import * as yup from 'yup';
import type { FieldType } from '../../types/EvalancheTypes';

export const fieldValidations = {
  form_EMAIL: (field: FieldType) =>
    field.required
      ? yup
          .string()
          .email(field.translation?.validation_error)
          .required(field.translation?.validation_error)
      : yup.string().email(field.translation?.validation_error),
  form_EMAIL_CONFIRMATION: (field: FieldType) =>
    yup
      .string()
      .email(field.translation?.validation_error)
      .required(field.translation?.validation_error)
      .when('form_EMAIL', {
        is: (val: string) => val?.length > 0,
        // biome-ignore lint/suspicious/noThenProperty: yup specific then
        then: () =>
          yup.string().oneOf([yup.ref('form_EMAIL')], field?.translation?.validation_error),
      }),
  password: (field: FieldType) =>
    field.required
      ? yup.string().required(field.translation?.validation_error).min(8, 'Too short')
      : yup.string().min(8, 'Too short'),
  textarea: (field: FieldType) =>
    field.required ? yup.string().required(field.translation?.validation_error) : yup.string(),
  text: (field: FieldType) => {
    if (field.widget_id === 8) {
      // in the future strict might need to be disabled
      return field.required
        ? yup.string().strict(false).trim().required(field.translation?.validation_error)
        : yup.string().strict(false).trim();
      // eslint-disable-next-line no-else-return
    } else if (field.widget_id === 27) {
      return field.required
        ? yup
            .string()
            .strict(true)
            .lowercase(field.translation?.validation_error)
            .required(field.translation?.validation_error)
        : yup.string().strict(true).lowercase(field.translation?.validation_error);
    } else if (field.widget_id === 28) {
      return field.required
        ? yup
            .string()
            .strict(true)
            .uppercase(field.translation?.validation_error)
            .required(field.translation?.validation_error)
        : yup.string().strict(true).uppercase(field.translation?.validation_error);
    } else {
      return field.required
        ? yup.string().required(field.translation?.validation_error)
        : yup.string();
    }
  },
  FormCheckbox: (field: FieldType) =>
    field.required
      ? yup.boolean().required(field.translation?.validation_error).oneOf([true])
      : yup.boolean(),
  radio: (field: FieldType) =>
    field.required ? yup.string().required(field.translation?.validation_error) : yup.string(),
  date: (field: FieldType) => {
    if (field.widget_id === 29 || field.widget_id === 30) {
      return field.required
        ? yup
            .date()
            .required(field.translation?.validation_error)
            .max(new Date(), field.translation?.validation_error)
        : yup.date().max(new Date(), field.translation?.validation_error);
      // eslint-disable-next-line no-else-return
    } else if (field.widget_id === 16 || field.widget_id === 17) {
      return field.required
        ? yup
            .date()
            .required(field.translation?.validation_error)
            .min(new Date(), field.translation?.validation_error)
        : yup.date().min(new Date(), field.translation?.validation_error);
    } else {
      return field.required ? yup.date().required(field.translation?.validation_error) : yup.date();
    }
  },
  select: (field: FieldType) =>
    field.required ? yup.string().required(field.translation?.validation_error) : yup.string(),
};

export const validationSchemaMap = (fields?: FieldType[]) => {
  const schema: any = {};

  fields?.forEach((field: FieldType) => {
    // @ts-expect-error
    if (fieldValidations[field.type]) {
      if (field.name === 'form_EMAIL' || field.name === 'form_EMAIL_CONFIRMATION') {
        schema[field.name] = fieldValidations[field.name](field);
      } else {
        schema[field.name] = fieldValidations[field.type as keyof typeof fieldValidations](field);
      }
    }
  });

  return schema;
};
